import { useMemo } from 'react';
import { processArtworkColors, type ProcessedColors } from '@/utils/brandPalette';

function useProcessColors(colors?: string[]): ProcessedColors {
  return useMemo(() => {
    if (typeof window === 'undefined') return { combinedStyle: undefined, hexColors: undefined };
    return processArtworkColors(colors);
  }, [colors]);
}

export default useProcessColors;
